import React from "react";
import Box from "@mui/material/Box";
import { Typography, Grid2, Button } from "@mui/material";
import styles from "./Home.module.css";
import "../";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Container from "@mui/material/Container";
import { motion } from "framer-motion";
import Hero from "./Hero";

// Data-driven project cards
const FEATURED_PROJECTS = [
  {
    id: 1,
    name: "Space Orbit",
    symbol: "Orbit",
    logo: "/images/spaceorbit.jpg",
    addedDate: "Sep 9",
  },
  {
    id: 2,
    name: "Nitro Max",
    symbol: "NTM",
    logo: "/images/image7.png",
    addedDate: "Sep 9",
  },
  {
    id: 3,
    name: "Mighty Astro",
    symbol: "MYA",
    logo: "/images/mightyastro.jpg",
    addedDate: "Sep 9",
  },
];

const Home = () => {
  const [network, setNetwork] = React.useState("Trendpad Mainnet");

  const handleNetworkChange = (event) => {
    setNetwork(event.target.value);
  };

  return (
    <main>
      <Box sx={{ flexGrow: 1 }}>
        <Hero />
        <Container>
          <Box
            mt={5}
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              alignItems: "center",
              flexWrap: "wrap",
              gap: "20px",
              width: "100%",
            }}
          >
            {/* Network Dropdown */}
            <Box
              sx={{
                width: { xs: "100%", sm: "auto" },
                maxWidth: { xs: "270px", sm: "none" }, // Match box width on mobile
                margin: { xs: "0 auto", sm: "0" }, // Center on mobile
                "& .MuiFormControl-root": {
                  width: "100%",
                },
              }}
            >
              <FormControl fullWidth>
                <Select
                  value={network}
                  onChange={handleNetworkChange}
                  aria-label="Select blockchain network"
                  inputProps={{
                    "aria-label": "Blockchain network selector",
                  }}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "8px",
                    borderRadius: "17px",
                    boxShadow: "0px -2px 5px 0px rgba(0, 0, 0, 0.25) inset",
                    fontFamily: '"DM Sans", sans-serif',
                    fontSize: { xs: "14px", sm: "16px" },
                    fontWeight: 400,
                    lineHeight: "normal",
                    background: (theme) =>
                      theme.palette.mode === "light"
                        ? "#FFFFFF"
                        : "var(--bg,linear-gradient(226deg, #2299b7 -39.46%, #0a0b2a 94.74%))",
                    border: (theme) =>
                      theme.palette.mode === "light"
                        ? "1px solid #E0E0E0"
                        : "none",
                    color: (theme) =>
                      theme.palette.mode === "light" ? "#121212" : "#fff",
                    "& .MuiSelect-select": {
                      padding: "8px 32px 8px 12px",
                      display: "flex",
                      alignItems: "center",
                      minWidth: "fit-content",
                    },
                    "& .MuiSelect-icon": {
                      color: (theme) =>
                        theme.palette.mode === "light" ? "#121212" : "#fff",
                      right: "8px",
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                    },
                    width: "100%",
                  }}
                >
                  <MenuItem
                    value={"Trendpad Mainnet"}
                    sx={{
                      py: 0.5,
                      "&.MuiMenuItem-root": {
                        minHeight: "auto",
                      },
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: { xs: "8px", sm: "12px" },
                        width: "100%",
                      }}
                    >
                      <img
                        height="20px"
                        width="20px"
                        src="/images/ethereum.png"
                        alt="Trendpad Mainnet"
                        style={{ flexShrink: 0 }}
                      />
                      <Typography
                        variant="body1"
                        sx={{
                          textTransform: "none",
                          fontStyle: "normal",
                          lineHeight: 1.2,
                          fontSize: { xs: "14px", sm: "16px" },
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        Trendpad Mainnet
                      </Typography>
                    </Box>
                  </MenuItem>
                </Select>
              </FormControl>
            </Box>
          </Box>

          <Box
            mt={5}
            sx={{
              textAlign: {
                xs: "center",
                md: "left",
                sm: "left",
                lg: "left",
              },
            }}
          >
            <Typography
              variant="h5"
              sx={{
                fontWeight: "500",
                lineHeight: "normal",
                fontStyle: "normal",
              }}
            >
              <span
                style={{
                  background:
                    "linear-gradient(90deg, rgba(34, 153, 183, 1) 0%, rgba(26, 28, 102, 1) 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  lineHeight: "normal",
                  fontStyle: "normal",
                }}
              >
                Newest
              </span>{" "}
              on Trendpad Mainnet{" "}
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: { xs: "center", sm: "flex-start" },
              flexWrap: "wrap",
              gap: "30px",
            }}
            mt={4}
          >
            {FEATURED_PROJECTS.map((project) => (
              <Box
                key={project.id}
                role="article"
                aria-label={`${project.name} project card`}
                sx={{
                  padding: "32px 40px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "12px",
                  borderRadius: "16px",
                  width: { xs: "100%", sm: "380px" }, // Full width on mobile, fixed on desktop
                  maxWidth: "360px", // Prevent growing too large
                  minHeight: "240px", // Consistent height
                  background: (theme) =>
                    theme.palette.mode === "light"
                      ? "rgba(255, 255, 255, 0.9)"
                      : "#1A1F2B",
                  border: (theme) =>
                    theme.palette.mode === "light"
                      ? "1px solid rgba(0, 0, 0, 0.05)"
                      : "1px solid rgba(0, 255, 255, 0.15)",
                  boxShadow: (theme) =>
                    theme.palette.mode === "light"
                      ? "0 4px 20px rgba(0, 0, 0, 0.05)"
                      : "0 0 20px rgba(0, 255, 255, 0.05)",
                  backdropFilter: "blur(20px)",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    borderColor: (theme) =>
                      theme.palette.mode === "light"
                        ? "rgba(0, 0, 0, 0.1)"
                        : "rgba(0, 255, 255, 0.5)",
                    boxShadow: (theme) =>
                      theme.palette.mode === "light"
                        ? "0 8px 25px rgba(0, 0, 0, 0.1)"
                        : "0 0 30px rgba(0, 255, 255, 0.15)",
                    transform: "scale(1.02)",
                  },
                }}
              >
                <Box
                  sx={{
                    width: "80px",
                    height: "80px",
                    borderRadius: "50%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    background: (theme) =>
                      theme.palette.mode === "light"
                        ? "rgba(0, 0, 0, 0.03)"
                        : "rgba(255, 255, 255, 0.05)",
                    border: (theme) =>
                      `1px solid ${theme.palette.mode === "light"
                        ? "rgba(0, 0, 0, 0.08)"
                        : "rgba(0, 255, 255, 0.2)"
                      }`,
                    boxShadow: (theme) =>
                      theme.palette.mode === "light"
                        ? "none"
                        : "0 0 15px rgba(0, 255, 255, 0.1)",
                    mb: 1,
                  }}
                >
                  <img
                    src={project.logo}
                    alt={`${project.name} project logo`}
                    style={{
                      width: "100%",
                      height: "100%",
                      maxWidth: "50px",
                      maxHeight: "50px",
                      borderRadius: "50%",
                      objectFit: "contain"
                    }}
                  />
                </Box>
                <Typography variant="h6" color="text.primary">
                  {project.name}
                </Typography>
                <Typography variant="body1" color="text.secondary">
                  {project.symbol}
                </Typography>
                <Button
                  variant="outlined"
                  size="small"
                  sx={{
                    borderRadius: "8px",
                    border: (theme) =>
                      `1px solid ${theme.palette.mode === "light"
                        ? "#E0E0E0"
                        : "#F1F1F1"
                      }`,
                    color: "text.primary",
                    textTransform: "none",
                    pointerEvents: "none", // Static badge, not clickable
                  }}
                >
                  Added {project.addedDate}
                </Button>
              </Box>
            ))}
          </Box>
        </Container>
      </Box>
    </main>
  );
};

export default Home;
